import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.number.to-fixed.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "w-100 align-items-center d-flex justify-content-between"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  "class": "fa fa-usd mr-1"
}, null, -1);

var _hoisted_3 = {
  "class": "text-right"
};
var _hoisted_4 = {
  "class": "text-right"
};
var _hoisted_5 = {
  "class": "text-right"
};
var _hoisted_6 = {
  key: 0,
  "class": "float-right"
};

var _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  "class": "fa fa-comment mr-1",
  "aria-hidden": "true"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ReSteem = _resolveComponent("ReSteem");

  var _component_vote_model = _resolveComponent("vote-model");

  var _component_el_avatar = _resolveComponent("el-avatar");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_link = _resolveComponent("el-link");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("span", null, [_hoisted_2, _createElementVNode("b", null, _toDisplayString(parseFloat($props.blogs.pending_payout_value.replace("SBD", "")) == 0 ? (parseFloat($props.blogs.author_payout_value.replace("SBD", "")) + parseFloat($props.blogs.curator_payout_value.replace("SBD", ""))).toFixed(3) : $props.blogs.pending_payout_value.replace("SBD", "")), 1)])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, [_createElementVNode("i", {
    "class": _normalizeClass(["fa fa-thumbs-o-up mr-1", [{
      'text-green': $options.isUpvote || $data.isOnUpvote
    }]]),
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.voteNewActivity && $options.voteNewActivity.apply($options, arguments);
    })
  }, null, 2), _createElementVNode("b", {
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.showVoters && $options.showVoters.apply($options, arguments);
    })
  }, _toDisplayString($options.upvoteNum), 1)])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, [_createElementVNode("i", {
    "class": _normalizeClass(["fa fa-thumbs-o-down mr-1", [{
      'text-red': $options.isDownvote
    }]]),
    "aria-hidden": "true"
  }, null, 2), _createElementVNode("b", null, _toDisplayString($options.downvoteNum), 1)])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_ReSteem, {
    isShowText: false,
    userName: $props.blogs.author,
    permlink: $props.blogs.permlink
  }, null, 8, ["userName", "permlink"])]), $props.isShowComment ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", null, [_hoisted_7, _createElementVNode("b", null, _toDisplayString($props.blogs.children), 1)])])) : _createCommentVNode("", true)]), _createVNode(_component_vote_model, {
    ref: "voteModel",
    post: $props.blogs,
    showModel: $data.showModel,
    onCloseModel: $options.closeModel,
    onVotePost: $options.votePost
  }, null, 8, ["post", "showModel", "onCloseModel", "onVotePost"]), _createVNode(_component_el_dialog, {
    modelValue: $data.isShowVoters,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.isShowVoters = $event;
    }),
    width: "90%"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_row, {
        gutter: 10
      }, {
        "default": _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.orderVoter($props.blogs.active_votes), function (item) {
            return _openBlock(), _createBlock(_component_el_col, {
              span: 12,
              key: item.voter,
              "class": "mt-2"
            }, {
              "default": _withCtx(function () {
                return [_createVNode(_component_el_row, {
                  gutter: 10
                }, {
                  "default": _withCtx(function () {
                    return [_createVNode(_component_el_col, {
                      span: 6,
                      "class": "text-right"
                    }, {
                      "default": _withCtx(function () {
                        return [_createVNode(_component_el_avatar, {
                          src: "https://steemitimages.com/u/" + item.voter + "/avatar/small"
                        }, null, 8, ["src"])];
                      }),
                      _: 2
                    }, 1024), _createVNode(_component_el_col, {
                      span: 2
                    }), _createVNode(_component_el_col, {
                      span: 16
                    }, {
                      "default": _withCtx(function () {
                        return [_createElementVNode("div", null, [_createVNode(_component_el_link, {
                          underline: false,
                          type: "primary",
                          href: "/@" + item.voter,
                          target: "_blank"
                        }, {
                          "default": _withCtx(function () {
                            return [_createTextVNode(_toDisplayString(item.voter), 1)];
                          }),
                          _: 2
                        }, 1032, ["href"])]), _createElementVNode("div", null, "$" + _toDisplayString($options.getVoterAmount(item.rshares)), 1)];
                      }),
                      _: 2
                    }, 1024)];
                  }),
                  _: 2
                }, 1024)];
              }),
              _: 2
            }, 1024);
          }), 128))];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])], 64);
}